import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import { SnackbarProvider } from 'notistack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const snackbarConfig = {
  maxSnack: 3,
  anchorOrigin: { vertical: 'top', horizontal: 'center' },
  autoHideDuration: 3000,
  iconVariant: {
    success: <CheckCircleIcon style={{ color: 'white' }} />,
    error: <ErrorIcon style={{ color: 'white' }} />,
    info: <InfoIcon style={{ color: 'white' }} />,
    warning: <WarningIcon style={{ color: 'white' }} />,
  },
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider {...snackbarConfig}>
        <Router>
          <App />
        </Router>
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
